




















import { defineComponent } from "@vue/composition-api";
import { getMediaDuration } from "@scrile/tools/dist/lib/TimeHelpers";
import { StoryFeed } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "StorySubscribeView",
  methods: { getMediaDuration },
  components: { BaseIcon, BaseButton },
  props: {
    story: { required: true, type: Object as () => StoryFeed },
  },
});
